import { useState } from 'react';
import { marked } from 'marked';
import { Icon } from '../components/Icon';
import contrattoMd from '../../../../docs/contratto-clausole-privacy.md?raw';
import notaCommercialistaMd from '../../../../docs/nota-commercialista.md?raw';
import seoGoogleMd from '../../../../docs/seo-google.md?raw';
import dominioClienteMd from '../../../../docs/dominio-cliente.md?raw';
import onboardingClienteMd from '../../../../docs/onboarding-cliente.md?raw';

/** Documenti dello studio, leggibili dalla Console (bundlati a build time → la
 *  Console mostra sempre l'ultima versione committata). Visibili a tutti
 *  (operatore e partner): sono guide e modelli utili a lavorare/onboardare. */
const DOCUMENTS = [
  {
    id: 'onboarding-cliente',
    title: 'Onboarding cliente — da "sì" alla consegna',
    detail: 'La guida madre, 10 passi: dal sì del cliente al sito pronto consegnato (crea → stile → bozza → dominio → Crea sito → consegna)',
    file: 'onboarding-cliente.md',
    body: onboardingClienteMd,
  },
  {
    id: 'dominio-cliente',
    title: 'Mettere un cliente sul suo dominio',
    detail: 'I 2 record DNS che il cliente aggiunge (@ e www) + l’ordine giusto per il "Crea sito"',
    file: 'dominio-cliente.md',
    body: dominioClienteMd,
  },
  {
    id: 'seo-google',
    title: 'SEO e Google — sitemap e Search Console',
    detail: 'Cosa fa già il sito da solo e i 10 minuti da fare per ogni cliente (Search Console + Business Profile)',
    file: 'seo-google.md',
    body: seoGoogleMd,
  },
  {
    id: 'contratto-privacy',
    title: 'Contratto — clausole privacy e responsabilità',
    detail: 'Modello con Allegato A (art. 28 GDPR), doppia firma e checklist',
    file: 'contratto-clausole-privacy.md',
    body: contrattoMd,
  },
  {
    id: 'nota-commercialista',
    title: 'Nota per il commercialista del cliente',
    detail: 'TD17 / reverse charge spiegato — da allegare alla prima fattura di ogni cliente',
    file: 'nota-commercialista.md',
    body: notaCommercialistaMd,
  },
];

export function DocsView() {
  const [openDoc, setOpenDoc] = useState<(typeof DOCUMENTS)[number] | null>(null);

  const download = (doc: (typeof DOCUMENTS)[number]) => {
    const url = URL.createObjectURL(new Blob([doc.body], { type: 'text/markdown' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = doc.file;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="view">
      <div className="view-pad rs-stack" style={{ maxWidth: 820 }}>
        <div className="rs-card">
          <div className="rs-card-head">
            <span className="rs-card-title">Documenti</span>
          </div>
          <div className="rs-dl">
            {DOCUMENTS.map((doc) => (
              <div className="rs-dl-row" key={doc.id}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                  <span className="rs-feed-ico">
                    <Icon name="list" size={15} />
                  </span>
                  <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                    <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--ink)' }}>{doc.title}</span>
                    <span className="rs-mini-meta">{doc.detail}</span>
                  </span>
                </span>
                <span style={{ display: 'inline-flex', gap: 8, flex: 'none' }}>
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => setOpenDoc(doc)}>Leggi</button>
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => download(doc)}>Scarica</button>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {openDoc && (
        <div className="mscrim open" onMouseDown={() => setOpenDoc(null)}>
          <div className="modal doc-modal" role="dialog" aria-modal="true" aria-label={openDoc.title} onMouseDown={(e) => e.stopPropagation()}>
            <div className="modal-head">
              <h3>{openDoc.title}</h3>
              <button type="button" className="dr-close" onClick={() => setOpenDoc(null)} aria-label="Chiudi">
                <Icon name="x" size={18} />
              </button>
            </div>
            {/* Our own bundled markdown — not user input, safe to render. */}
            <div className="modal-body doc-md" dangerouslySetInnerHTML={{ __html: marked.parse(openDoc.body) as string }} />
            <div className="modal-foot">
              <span className="rs-muted" style={{ fontSize: 12 }}>Modello — da personalizzare e far revisionare prima della firma.</span>
              <div className="grow" />
              <button type="button" className="btn btn-primary" onClick={() => download(openDoc)}>Scarica</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
